module.exports = __webpack_public_path__ + "img/01_Quiet-Cove-025.6007da20.jpg";